import * as React from "react";
import { Typography, Link, Content } from "components";
import classNames from "classnames";
import styles from "./Footer.module.css";

interface FooterProps {
  className?: string;
}

const Footer: React.FC<FooterProps> = ({ className = "" }) => (
  <footer className={classNames(className, styles.wrapper)}>
    <Content className={styles.content}>
      <Typography component="span" variant="c2">
        &copy;&nbsp;{new Date().getFullYear()},&ensp;Accelerate Learning,
        Inc.&ensp;All Rights Reserved.&ensp;
        <Link
          to="//acceleratelearning.com/terms"
          target="_blank"
          rel="noreferrer noopener nofollow"
        >
          Terms and Conditions
        </Link>
      </Typography>
    </Content>
  </footer>
);

export default Footer;
